import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/password.ts
import { generateMd5, getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var forgotPassword = (_0) => __async(null, [_0], function* ({ email, locale, checkout_verify, app_source }) {
  var _a, _b, _c, _d;
  try {
    const signature = generateMd5(email);
    const captcha = yield resolveCaptcha("forgot_password");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/forgot-password",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({
          email
        }, captcha), {
          signature,
          lang,
          checkout_verify,
          app_source
        }))
      }
    });
    if (((_c = data.status) == null ? void 0 : _c.toLowerCase()) !== "success" || ((_d = data == null ? void 0 : data.error) == null ? void 0 : _d.code)) {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || (data == null ? void 0 : data.error) || data.verify_message || "Something went wrong...";
      throw new Error(String(msg));
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "forgotPasswordException",
      context: { tags: { journey: "auth" }, extra: { email } }
    });
  }
});
var changePassword = (props) => __async(null, null, function* () {
  var _a, _b, _c, _d;
  try {
    const signature = generateMd5(props.new_password);
    const captcha = yield resolveCaptcha("resetpassword");
    const data = yield fetchClient({
      url: "/change-password",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, props), {
          signature
        }), captcha), {
          email: props.email,
          lang: getLocaleOnly(props.lang)
        }))
      }
    });
    const error = typeof (data == null ? void 0 : data.error) === "string" ? data.error : (_c = data == null ? void 0 : data.error) == null ? void 0 : _c.code;
    if (((_d = data.status) == null ? void 0 : _d.toLowerCase()) !== "success" || error) {
      throw new Error(error || "Something went wrong...");
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "changePasswordException"
    });
  }
});
var updatePassword = (_0) => __async(null, [_0], function* ({
  lang,
  current_password,
  password,
  retype_password
}) {
  var _a, _b, _c, _d;
  try {
    const signature = generateMd5(password);
    const captcha = yield resolveCaptcha("update_password");
    const data = yield fetchClient({
      url: "/update-password",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, captcha), {
          signature,
          lang: getLocaleOnly(lang),
          current_password,
          password,
          retype_password
        }))
      }
    });
    const error = typeof (data == null ? void 0 : data.error) === "string" ? data.error : (_c = data == null ? void 0 : data.error) == null ? void 0 : _c.code;
    if (((_d = data.status) == null ? void 0 : _d.toLowerCase()) !== "success" || error) {
      throw new Error(error || "Something went wrong...");
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "updatePasswordException",
      context: error
    });
  }
});

export {
  forgotPassword,
  changePassword,
  updatePassword
};
//# sourceMappingURL=chunk-5DW6DKSR.mjs.map